import { useRef } from "react";
import { Button, Card, Col, Row, Container } from "react-bootstrap";
import about3 from "../assets/images/about3.jpg";
import about from "../assets/images/about.jpg";
import { color, motion, useInView } from "framer-motion";
import { ReactComponent as MobileIcon } from "../assets/images/mobile.svg";
import { ReactComponent as DesignIcon } from "../assets/images/web-design.svg";
import { ReactComponent as WebIcon } from "../assets/images/web-coding.svg";
import html from "../assets/images/html-5.svg";
import css from "../assets/images/css-3.svg";
import javascript from "../assets/images/js.svg";
import java from "../assets/images/java.svg";
import react from "../assets/images/react.svg";
import photoshop from "../assets/images/photoshop.svg";
import figma from "../assets/images/figma.svg";
import aws from "../assets/images/aws.svg";
import mongo from "../assets/images/mongodb.svg";
import kotlin from "../assets/images/kotlin.svg";
import android from "../assets/images/android.svg";
import node from "../assets/images/node-js.svg";
import { useNavigate } from "react-router-dom";
import "./Homecontent.css";

function Homecontent() {
  const cardVariant = {
    hidden: { opacity: 0, x: -100 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.6, duration: 1, type: "tween" },
    }),
  };
  const cardVariant2 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2, // faster stagger
        duration: 0.5, // faster animation
        type: "tween",
      },
    }),
  };
  const navigate = useNavigate();

  const servicesRef = useRef(null);
  const contactRef = useRef(null);
  const techRef = useRef(null);
  const missonRef = useRef(null);

  // Check if elements are in view
  const servicesInView = useInView(servicesRef, { once: true, amount: 0.2 });
  const contactInView = useInView(contactRef, { once: true, amount: 0.5 });
  const tchInView = useInView(techRef, { once: true, amount: 0.5 });
  useInView(missonRef, { once: true, amount: 0.5 });

  const technology = [
    {
      id: 1,
      image: android,
      title: "Android App",
      backContent:
        "An open-source mobile operating system by Google designed for smartphones and tablets.",
      backColor: "#13AA52",
    },
    {
      id: 2,
      image: photoshop,
      title: "Photoshop",
      backContent:
        "A powerful image editing and graphic design application used to create and enhance visuals.",
      backColor: "#3571A3",
    },
    {
      id: 3,
      image: figma,
      title: "Figma",
      backContent:
        "A collaborative UI/UX design platform used for building wireframes, prototypes, and user interfaces.",
      backColor: "#FF7361",
    },
    {
      id: 4,
      image: html,
      title: "HTML 5",
      backContent:
        "The standard markup language used to create and structure content on the web.",
      backColor: "#E44D26",
    },
    {
      id: 5,
      image: css,
      title: "CSS 3",
      backContent:
        "The latest version of CSS used to style and lay out web pages with advanced visual effects.",
      backColor: "#61dafb",
    },
    {
      id: 6,
      image: javascript,
      title: "JavaScript",
      backContent:
        "A programming language that powers interactive and dynamic behavior on websites.",
      backColor: "#8B8000",
    },
    {
      id: 7,
      image: java,
      title: "Java",
      backContent:
        "A programming language designed to have minimal implementation dependencies.",
      backColor: "#FF930E",
    },
    {
      id: 8,
      image: react,
      title: "React",
      backContent: "A JavaScript library used for building user interfaces.",
      backColor: "#2196F3",
    },
    {
      id: 9,
      image: node,
      title: "NodeJS",
      backContent:
        "A high-performance JavaScript runtime for building backend services.",
      backColor: "#178B17",
    },
    {
      id: 10,
      image: mongo,
      title: "Mongo DB",
      backContent:
        "A NoSQL database that lets you store, manage, and work with data in the cloud.",
      backColor: "#13AA52",
    },
    {
      id: 11,
      image: aws,
      title: "AWS",
      backContent:
        "One of the most powerful and widely used cloud computing platforms.",
      backColor: "#FF9900",
    },
    {
      id: 12,
      image: kotlin,
      title: "Kotlin",
      backContent:
        "A modern, concise, and safe programming language used mainly for Android application development.",
      backColor: "#2D8AD8",
    },
  ];

  return (
    <>
      {/* About Us Section - Matching 2nd Image Design */}
      <div className="about-section-homepage">
        <Container>
          <Row className="align-items-center">
            <div className="about-title">About Us</div>
            <p className="section-subtitle">
              Smart digital solutions that help businesses grow.
            </p>
            <Col lg={6} md={12} className="about-image-col">
              <motion.img
                src={about}
                alt="About Us"
                className="about-homepage-image"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              />
            </Col>
            <Col lg={6} md={12} className="about-content-col">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <div className="about-quote-section">
                  <div className="quote-icon" aria-hidden="true" />
                  <p className="about-intro-text">
                    At{" "}
                    <strong className="company-name-highlight">
                      Lyra Infotech
                    </strong>
                    , we engineer scalable digital ecosystems — mobile
                    applications and web platforms designed to serve millions
                    and built to scale to billions.
                  </p>
                </div>
                <p className="about-description-text">
                  We operate at the intersection of performance, usability, and
                  global reach — building products that don’t just function, but
                  lead markets.
                </p>
                <div className="about-cta-section">
                  <div className="cta-icon">🚀</div>
                  <div className="cta-content">
                    <h4 className="cta-title">
                      Ready to Build at Global Scale?
                    </h4>
                    <p className="cta-subtitle">
                      Let's transform your vision into a high-performance
                      digital platform!
                    </p>
                  </div>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Services Section - Matching 3rd Image Design (2x3 Grid) */}
      <div className="services-section-homepage">
        <Container>
          <div className="services-homepage-title"> Our Products</div>
          <p className="section-subtitle">
            Products designed for performance and real-world impact.
          </p>
          <Row className="services-grid-homepage" ref={servicesRef}>
            {[
              {
                icon: (
                  <WebIcon
                    style={{
                      height: "40px",
                      fill: "#14b8a6",
                      stroke: "#14b8a6",
                    }}
                  />
                ),
                title: "Scalable Web Platforms",
                description:
                  "We build high-performance web platforms designed for global scale. From content ecosystems to interactive digital environments, our platforms are engineered for speed, security, and long-term growth.",
                iconColor: "#14b8a6",
              },
              {
                icon: (
                  <MobileIcon
                    style={{
                      height: "40px",
                      fill: "#ec4899",
                      stroke: "#ec4899",
                    }}
                  />
                ),
                title: "Global Mobile Applications",
                description:
                  "Our mobile applications power productivity, creativity, and everyday digital life. Designed for the Play Store and App Store, they are optimized for scale, performance, and global reach.",
                iconColor: "#ec4899",
              },
              {
                icon: (
                  <DesignIcon
                    style={{
                      height: "40px",
                      fill: "#10b981",
                      stroke: "#10b981",
                    }}
                  />
                ),
                title: "Tools & Utility Ecosystems",
                description:
                  "We develop intelligent digital tools that simplify complex tasks and enhance user efficiency. Every product is built with scalability, automation, and long-term usability in mind.",
                iconColor: "#10b981",
              },
              {
                icon: (
                  <DesignIcon
                    style={{
                      height: "40px",
                      fill: "#0089f9",
                      stroke: "#0089f9",
                    }}
                  />
                ),
                title: "Content & Gaming Platforms",
                description:
                  "From professional blogging infrastructures to engaging gaming platforms, we create web experiences designed to grow communities and reach millions worldwide.",
                iconColor: "#0089f9",
              },
            ].map((service, i) => (
              <Col lg={6} md={6} sm={12} key={i} className="mb-4">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.6 }}
                >
                  <Card
                    className="service-card-homepage"
                    onClick={() => navigate("/services")}
                  >
                    <Card.Body>
                      <div
                        className="service-icon-homepage"
                        style={{ color: service.iconColor }}
                      >
                        {service.icon}
                      </div>
                      <h4 className="service-title-homepage">
                        {service.title}
                      </h4>
                      <p className="service-description-homepage">
                        {service.description}
                      </p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div
        className="contenct-div2 text-center d-flex justify-content-center align-items-center"
        ref={contactRef}
      >
        <Row>
          <Col>
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={
                contactInView ? { y: 0, opacity: 1 } : { y: 50, opacity: 0 }
              }
              transition={{ duration: 0.8 }}
            >
              <h2 className="info" style={{ color: "black" }}>
                Partner with Lyra Infotech to reach new technological heights
              </h2>
              <Button
                className="contact-btn mt-3"
                onClick={() => {
                  navigate("contact");
                }}
              >
                Let's Talk
              </Button>
            </motion.div>
          </Col>
        </Row>
      </div>
      <div className="container tech-div " ref={techRef}>
        <div className="text-center ">
          <h2 className="bold-text h2-tech-title">Our Technology</h2>
          <div className="tech-subtitle" style={{ color: "black" }}>
            Modern technologies powering fast, scalable digital solutions.
          </div>
        </div>
        <div className="mt-5">
          <Row className="align-items-stretch">
            {technology.map((item, i) => (
              <Col
                lg={3}
                md={4}
                sm={6}
                xs={12}
                key={i}
                className="mb-4 tech-col"
              >
                {/* <Card className="tech-card">
                  <Card.Body>
                    <img src={item.image} alt="" style={{ height: "60px" }} />
                    <h5 className="fw-bold mt-3">{item.title}</h5>
                  </Card.Body>
                </Card> */}
                <motion.div
                  custom={i}
                  initial="hidden"
                  animate={tchInView ? "visible" : "hidden"}
                  variants={cardVariant2}
                  // viewport={{ once: false, amount: 0.1 }}
                  whileInView="visible"
                >
                  <Card className="tech-card-modern h-100">
                    <Card.Body className="text-center">
                      <div
                        className="tech-icon-wrapper"
                        style={{ backgroundColor: `${item.backColor}15` }}
                      >
                        <img src={item.image} alt={item.title} />
                      </div>

                      <h5 className="tech-title">{item.title}</h5>

                      <p className="tech-description">{item.backContent}</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
      {/* Careers Section - Matching 4th Image Design */}
      <div className="careers-section-homepage" ref={missonRef}>
        <Container>
          {/* Top Section - White Background */}
          <motion.div
            className="careers-top-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="careers-main-title">
              Build the Future With Lyra Infotech
            </h2>
            <p className="careers-intro-text">
              At Lyra Infotech, we engineer scalable digital products built for
              global reach and long-term impact. Join a team that goes beyond
              features to architect platforms that shape how people experience
              technology.
            </p>
            <h3 className="careers-subtitle">
              We hire thinkers. We build leaders.
            </h3>
            <a href="/careers" className="careers-hiring-link">
              Explore Opportunities
            </a>
          </motion.div>

          {/* Middle Section - Muted Blue Background */}
          <motion.div
            className="careers-middle-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            <h2 className="careers-section-title">
              We Build Careers That Scale — Just Like Our Products
            </h2>
            <p className="careers-description-text">
              Lyra Infotech is building a billion-user digital ecosystem across
              mobile and web platforms. We value ambition, ownership, and
              long-term thinking, driven by a product-first mindset, global
              scalability, and continuous innovation. If you want to build
              products that impact users worldwide — not just projects — this is
              your platform.
            </p>
            <div className="careers-buttons">
              <Button
                className="careers-btn-primary"
                onClick={() => navigate("/careers")}
              >
                View Open Roles
              </Button>
              <Button
                className="careers-btn-secondary"
                onClick={() => navigate("/careers")}
              >
                Apply For Internship
              </Button>
            </div>
          </motion.div>

          {/* Bottom Section - Lighter Muted Blue Background */}
          <motion.div
            className="careers-bottom-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <p className="careers-question">
              Can't Find the Right Role? <br />
              <a
                href="mailto:info@lyrainfotech.com"
                className="careers-email-link"
              >
                Send your resume to{" "}
                <strong>
                  <b>info@lyrainfotech.com</b>
                </strong>
              </a>
            </p>
          </motion.div>
        </Container>
      </div>
    </>
  );
}

export default Homecontent;
